import React, { useState, useEffect, useRef } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { Button, Modal, Checkbox } from "antd";
import {PEButton, PETable, PETr} from './permissionComponents/index'
import { DownloadOutlined, EditOutlined, UploadOutlined, CopyOutlined } from "@ant-design/icons";

function View_list(props) {
  const [loading, sendRequest] = useAxios();
  const [viewList, setviewList] = useState();
  const [filteredviewList, setfilteredviewList] = useState();
  const [isErrOpen, setisErrOpen] = useState(false);
  const [isCopyModalOpen, setisCopyModalOpen] = useState(false);
  const [selectedView, setSelectedView] = useState(null);
  const [copyOptions, setCopyOptions] = useState({
    configHeader: false,
    dataSource: false,
    actionApi: false,
    getAPI: false,
  });
  const [getAPIMApping, setgetAPIMApping] = useState();
  const [api_error_message, setapi_error_message] = useState();
  const [
    effetive_designation_idList,
    seteffetive_designation_idList,
  ] = useState();
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [importJsonData, setImportJsonData] = useState(null);
  const [importFileName, setImportFileName] = useState("");
  const fileInputRef = useRef(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImportFileName(file.name);
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          setImportJsonData(jsonData);
          setImportModalVisible(true);
        } catch (error) {
          alert("Invalid JSON file");
        }
      };
      reader.readAsText(file);
    }
  };

  const handleImport = async () => {
    if (!importJsonData) return;

    let apitoken = localStorage.getItem("api_token");
    try {
      const response = await sendRequest({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/mongo/insert/configuration_master/webhook_configuration_view_master`,
        headers: {
          "api-token": apitoken,
        },
        data: JSON.stringify(importJsonData)
      });

      if (response.status == 1) {
        setImportModalVisible(false);
        setImportJsonData(null);
        setImportFileName("");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        // Refresh the list after successful import
        window.location.reload();
      }
    } catch (e) {
      setisErrOpen(true);
      setapi_error_message(e.message);
    }
  };
  useEffect(() => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/webhook/configuration/data`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setviewList(response);
      }
    );
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/designation/list`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        seteffetive_designation_idList(response);
      }
    );
  }, []);
  useEffect(() => {
    const filtered_data = freeSearch();
    console.log("filtered_data", filtered_data);
  }, [viewList]);

  const get_eftDesi = (eid) => {
    const foundDesignation =
      effetive_designation_idList &&
      effetive_designation_idList.find(
        (designation) => designation.effective_designation_id === eid
      );
    return foundDesignation && foundDesignation.designation_code;
  };

  const freeSearch = (strinput) => {
    console.log("strinput", strinput);

    const results = [];
    const data = viewList;
    if (strinput) {
      data.forEach((item) => {
        //const keys = Object.keys(item);
        const keys = "view_name";

        //for (let i = 0; i < keys.length; i++) {
        const value = item[keys];

        if (
          typeof value === "string" &&
          value.toLowerCase().includes(strinput.toLowerCase())
        ) {
          results.push(item);
          //break;
        } else if (typeof value === "number" || typeof value === "boolean") {
          if (value.toString().includes(strinput)) {
            results.push(item);
            // break;
          }
        } else if (Array.isArray(value)) {
          for (let j = 0; j < value.length; j++) {
            const arrayValue = value[j];
            if (
              typeof arrayValue === "string" &&
              arrayValue.toLowerCase().includes(strinput.toLowerCase())
            ) {
              results.push(item);
              //break;
            } else if (
              typeof arrayValue === "number" ||
              typeof arrayValue === "boolean"
            ) {
              if (arrayValue.toString().includes(strinput)) {
                results.push(item);
                //break;
              }
            }
          }
        }
        //}
      });
      console.log("results", results);

      //return results;
      setfilteredviewList(results);
    } else {
      //return data;
      setfilteredviewList(data);
    }
  };


  const handleCopy = (view) => {
    setSelectedView(view);
    setisCopyModalOpen(true);
    console.log("Selected view for copy:", view); 
  };

  const handleCopyConfirm = () => {
    setisCopyModalOpen(false);
    console.log("Copy data log:", copyOptions)
    props.history.push({
      pathname: "/View",
      state: {
        copyOptions,
        selectedView,
      },
    });
  };

  return (
    <div className="container">
      <Commonheader pagetitle={"View List"} props={props} />
      {loading && (
        <div className="load-4">
          <div className="ring-1"></div>
        </div>
      )}
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <PEButton  element_id="viewlist_closetext"
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
                window.location.reload();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </PEButton>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>
      <Modal
        title={`Import JSON - ${importFileName}`}
        visible={importModalVisible}
        onCancel={() => setImportModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setImportModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="import" type="primary" onClick={handleImport}>
            Import
          </Button>
        ]}
      >
        {importJsonData && (
          <div>
            <h5>Preview:</h5>
            <pre style={{ maxHeight: '300px', overflow: 'auto' }}>
              {JSON.stringify(importJsonData, null, 2)}
            </pre>
          </div>
        )}
      </Modal>

      <div className="mt-4">
        <div className="row">
          <div className="col-md-9">
            <input className="form-control mb-2" placeholder="Search Here" onChange={(e) => freeSearch(e.target.value)} />
          </div>
          <div className="col-md-3">
            <input
              type="file"
              ref={fileInputRef}
              accept=".json"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
            />
            <button
              type="primary"
              icon={<UploadOutlined />}
              onClick={() => fileInputRef.current.click()}
              className="btn btn-primary form-control"
            >
              Import JSON
            </button>
          </div>
        </div>        
        <PETable element_id="viewlist_table" className="table">
          <thead className="thead-light">
            <PETr element_id="viewlist_tablerow">
              <th scope="col">View Name</th>
              <th scope="col">Bucket Name</th>
              <th scope="col">Event Name</th>
              <th scope="col">Effective Designation</th>
              <th scope="col">Action</th>
            </PETr>
          </thead>
          <tbody>
            {filteredviewList &&
              filteredviewList.map((list) => (
                <tr>
                  <td>
                    {list.view_name}{" "}
                    {!list.getpayloadfields ? (
                      <span className="errmessage">*</span>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>{list.bucket_name}</td>
                  <td>{list.event_name}</td>
                  <td>{get_eftDesi(list.effective_designation_id)}</td>
                  <td>
                    <div class="btn-group" role="group">
                      <div style={{ display: "flex", gap: "10px" }}>
                      <Button
                          type="button"
                          className="btn btn-outline-info btn-sm"
                          onClick={() =>
                            props.history.push({
                              pathname: "/View",
                              state: {
                                view_id: list.view_id,
                                payloadTile: true,
                                component_mapping: "",
                              },
                            })
                          }
                          icon={<EditOutlined />}
                      />
                        <Button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={() => handleCopy(list)}
                        icon={<CopyOutlined />}
                      />
                      </div>
                      <button
                        type="button"
                        class="btn btn-outline-success btn-sm"
                        onClick={() => {
                          const dataStr = JSON.stringify(list, null, 2);
                          const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
                          const exportFileDefaultName = `${list.view_name || 'data'}.json`;

                          const linkElement = document.createElement('a');
                          linkElement.setAttribute('href', dataUri);
                          linkElement.setAttribute('download', exportFileDefaultName);
                          linkElement.click();
                        }}
                      >
                        <DownloadOutlined />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </PETable>
      </div>
      <Modal
        title="Copy View Configuration"
        open={isCopyModalOpen}
        onOk={handleCopyConfirm}
        onCancel={() => setisCopyModalOpen(false)}
        okText="Submit"
        cancelText="Cancel"
      >
        <p>Select the parts to copy:</p>
        <Checkbox
          checked={copyOptions.configHeader}
          onChange={(e) =>
            setCopyOptions((prev) => ({
              ...prev,
              configHeader: e.target.checked,
            }))
          }
        >
          Configuration Header
        </Checkbox>
        <Checkbox
          checked={copyOptions.dataSource}
          onChange={(e) =>
            setCopyOptions((prev) => ({
              ...prev,
              dataSource: e.target.checked,
            }))
          }
        >
          Data Source
        </Checkbox>
        <Checkbox
          checked={copyOptions.actionApi}
          onChange={(e) =>
            setCopyOptions((prev) => ({
              ...prev,
              actionApi: e.target.checked,
            }))
          }
        >
          Action API
        </Checkbox>
        <Checkbox
          checked={copyOptions.getAPI}
          onChange={(e) =>
            setCopyOptions((prev) => ({
              ...prev,
              getAPI: e.target.checked,
            }))
          }
        >
          Get API
        </Checkbox>
      </Modal>
    </div>
  );
}

export default View_list;
